// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"11":"membercard","95":"handle-transfer","443":"about","571":"settings","584":"block","805":"transactions","809":"transfer"}[chunkId] + "-legacy." + {"11":"6d7e70b9","95":"53aad1de","443":"5a6706a9","571":"7c8c98ba","584":"f42761bc","805":"95858355","809":"9e59eb4d"}[chunkId] + ".js";
};